import { extendObservable, action } from 'mobx';

import { get, jsonParser } from '../utils/Client';

class EvolucaStore {
  constructor() {
    extendObservable(this, {
      indecisos: null,

      coligacoes: null,

      candidatos: null,

      intencoes: null,

      loadIndecisos: action(() =>
        get(`/evolucao/participacao`)
          .then(jsonParser)
          .then(data => (this.indecisos = data))
      ),

      loadColigacoes: action(() =>
        get(`/evolucao/coligacoes`)
          .then(jsonParser)
          .then(data => (this.coligacoes = data))
      ),

      loadCandidatosMajoritarios: action((tipo = null) =>
        get(`/evolucao/majoritario/candidatos${tipo ? '/' + tipo : ''}`)
          .then(jsonParser)
          .then(data => (this.candidatos = data))
      ),

      loadCandidatosProporcionais: action((tipo = null) =>
        get(`/evolucao/proporcional/candidatos` + (tipo ? '/' + tipo : ''))
          .then(jsonParser)
          .then(data => (this.candidatos = data))
      ),

      loadIntencoes: action((tipo, codigo) =>
        get(`/evolucao/${tipo}/intencoes/${codigo}`)
          .then(jsonParser)
          .then(data => (this.intencoes = data))
      ),
    });
  }
}

export default new EvolucaStore();



// WEBPACK FOOTER //
// ./src/stores/EvolucaoStore.js